<template>
  <div class="change-user-info">
    <div class="user-info-content">
      <!-- <div
        class="user-info-content-line"
        v-for="item in userInfo"
        :key="item.title"
      >
        <img :src="item.icon" :alt="item.title" class="info-icon" />
        <span class="info-lable">{{ item.title }}</span
        ><b>：</b><el-input v-model="item.content" class="info-content" />
      </div> -->
      <el-form :model="userInfo" :rules="rules" ref="userInfo">
        <div class="user-info-content-line">
          <img :src=userInfo.username.icon :alt="userInfo.username.title" class="info-icon" style="position:relative;top:-12px" />
          <span class="info-lable" style="position:relative;top:-12px">{{ userInfo.username.title }}</span>
          <b  style="position:relative;top:-12px">：</b>
          <el-form-item prop="username">
            <el-input v-model="userInfo.username.content" class="input-content" />
          </el-form-item>
        </div>
        <div class="user-info-content-line">
          <img :src=userInfo.phone.icon :alt="userInfo.phone.title" class="info-icon" style="position:relative;top:-12px" />
          <span class="info-lable" style="position:relative;top:-12px">{{ userInfo.phone.title }}</span
          ><b style="position:relative;top:-12px">：</b>
          <el-form-item prop="phone">
            <el-input v-model="userInfo.phone.content" class="input-content"/>
          </el-form-item>
        </div>
        <div class="user-info-content-line">
          <img :src=userInfo.mail.icon :alt="userInfo.mail.title" class="info-icon" style="position:relative;top:-12px" />
          <span class="info-lable" style="position:relative;top:-12px">{{ userInfo.mail.title }}</span
          ><b style="position:relative;top:-12px">：</b>
          <el-form-item prop="mail">
            <el-input v-model="userInfo.mail.content" class="input-content" />
          </el-form-item>
        </div>
        <div class="user-info-content-line">
          <img :src=userInfo.address.icon :alt="userInfo.address.title" class="info-icon" style="position:relative;top:-12px" />
          <span class="info-lable" style="position:relative;top:-12px">{{ userInfo.address.title }}</span>
          <b style="position:relative;top:-12px">：</b>
          <el-form-item prop="address">
            <el-input v-model="userInfo.address.content" class="input-content" />
          </el-form-item>
        </div>
      </el-form>
      <div class="user-info-content-line note">
        <img :src="note.icon" :alt="note.title" class="info-icon" />
        <span class="info-lable">备注</span><b>：</b
        ><el-input
          v-model="note.content"
          class="info-content"
          type="textarea"/>
      </div>
    </div>
  </div>
</template>

<script>
import MyDialog from './MyDialog.vue'
export default {
  components: { MyDialog },
  name: 'ChangeUserInfo',
  // props: {
  //   userInfo: {
  //     required: true
  //   },
  //   note: {
  //     required: true
  //   }
  // },
  data () {
    return {
      flag: false,
      userInfo: {
        username: {
          title: '用户名',
          content: 'admin',
          icon: require('@/assets/images/userPage/user.png')
        },
        phone: {
          title: '手机号',
          content: '123456789',
          icon: require('@/assets/images/userPage/phone.png')
        },
        mail: {
          title: '邮箱',
          content: '123456@123456.com',
          icon: require('@/assets/images/userPage/location.png')
        },
        address: {
          title: '联系地址',
          content: '这是联系地址',
          icon: require('@/assets/images/userPage/address.png')
        }
      },
      note: {
        title: '备注',
        content: '',
        icon: require('@/assets/images/userPage/chat.png')
      },
      rules: {
        phone: [
          { required: true, trigger: 'blur' },
          { validator: this.checkPhone, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    console.log('加载')
    this.getInfo()
  },
  methods: {
    getInfo () {
      this.userId = localStorage.getItem('userId')
      let url = 'retrieve/user/getPersonalIfo?userId=' + this.userId
      this.$http
      .get(url)
      .then(res => {
        // console.log(res.data.data)
        this.user = res.data.data
        this.userInfo.username.content = res.data.data.username
        this.userInfo.phone.content = res.data.data.phone
        this.userInfo.mail.content = res.data.data.email
        this.userInfo.address.content = res.data.data.address
        this.note.content = res.data.data.note
        this.flag = true
        // console.log(this.userInfo)
      })
      .catch(err => {
        console.log('获取个人信息失败', err)
      })
    },
    checkPhone (rule, value, callback) {
      if(!value.content) {
        this.flag = false
        callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3456789]\d{9}$/
        if(reg.test(value.content)) {
          this.flag = true
          console.log('格式正确')
          callback()
        } else {
          this.flag = false
          callback(new Error('请输入正确的手机号！'))
        }
      }
    }
  }
}
</script>

<style scoped>
.user-info-content {
  margin-left: 55px;
  margin-right: 55px;
  margin-top: 30px;
  margin-bottom: 40px;
}

.info-icon {
  width: 18px;
  margin-right: 7px;
}

.user-info-content-line {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: left;
  font-size: 16px;
}

.user-info-content-line.note {
  align-items: flex-start;
  margin-top: 11px;
}

.info-lable {
  width: 90px;
  font-weight: bold;
  text-align: justify;
  text-align-last: justify;
}

.info-content {
  margin-left: 28px;
}

.input-content {
  margin-left: 28px;
  width: 436px;
}

.change-user-info >>> .el-textarea__inner {
  border-radius: 0;
  border: 1px solid #634c37;
  padding-left: 30px;
  height: 70px;
  color: #634c37;
  font-family: myhei;
}

.change-user-info >>> .el-textarea__inner:focus {
  border: 1px solid #9e5c1d;
  font-size: 14px;
  /* padding: 0; */
}
</style>



// WEBPACK FOOTER //
// src/components/ChangeUserInfo.vue